const normalizeSourceContext = (value = '') => String(value || '').trim().toLowerCase();

const isLegacyMedicationExtractionStory = (entry = {}) => [
  entry.sourceMode,
  entry.inputMode,
  entry.source?.type,
  entry.source?.mode,
  entry.metadata?.captureFirst?.sourceType,
].some((value) => normalizeSourceContext(value) === 'medication_document')
  && normalizeSourceContext(
    entry.sourceContainerKind
    || entry.metadata?.timelinePlanner?.sourceContainerKind
    || entry.metadata?.timelinePlanner?.sourceContainer?.kind
  ) === 'story';

export const getTimelineEntrySourceContext = (entry = {}) => (
  normalizeSourceContext(
    entry.sourceContext
    || entry.sourceMetadata?.sourceContext
    || entry.metadata?.source?.sourceContext
    || entry.metadata?.careSourceProcessing?.sourceContext
    || entry.metadata?.captureFirst?.sourceContext
    || entry.source?.sourceContext
    || ''
  )
  || (isLegacyMedicationExtractionStory(entry) ? 'medication' : '')
);

export const isTimelineVisibleSourceEntry = (entry = {}) => {
  if (
    entry.hiddenFromTimeline === true
    || entry.archived === true
    || entry.reviewState === 'discarded'
    || entry.reviewStatus === 'discarded'
  ) {
    return false;
  }

  const sourceContext = getTimelineEntrySourceContext(entry);
  return !sourceContext || sourceContext === 'timeline';
};
